export const getToken = () => {
    return localStorage.getItem('access_token') ?? null;
}